"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.produceStateDisconnectedPlayers = exports.getSpellRangeArea = exports.produceStateFromSpellRole = exports.getSpellEffectFromSpellRole = exports.produceStateFromSpellEffect = void 0;
var common_1 = require("@timeflies/common");
var immer_1 = __importDefault(require("immer"));
var compute_checksum_1 = require("./compute-checksum");
var compute_range_area_1 = require("./compute-range-area");
var spell_effects_fn_1 = require("./spell-effects-fn");
var spell_effects_map_1 = require("./spell-effects-map");
var getDefineProp = function (source, characterId, delta) {
    return function (key, computeFn) {
        var deltaValue = delta[key];
        if (deltaValue !== undefined) {
            var variables = source[key];
            var prevValue = variables[characterId];
            variables[characterId] = computeFn(prevValue, deltaValue);
        }
    };
};
var produceStateFromSpellEffect = function (spellEffect, state, spellActionLaunchTime) {
    return immer_1.default(state, function (draft) {
        var _a, _b;
        Object.entries((_a = spellEffect.characters) !== null && _a !== void 0 ? _a : {})
            .forEach(function (_a) {
            var _b = __read(_a, 2), characterId = _b[0], characterDelta = _b[1];
            var defineProp = getDefineProp(draft.characters, characterId, characterDelta);
            defineProp('health', function (prevValue, deltaValue) { return prevValue + deltaValue; });
            defineProp('actionTime', function (prevValue, deltaValue) { return prevValue + deltaValue; });
            defineProp('orientation', function (prevValue, deltaValue) { return deltaValue; });
            defineProp('position', function (prevValue, deltaValue) { return deltaValue; });
        });
        Object.entries((_b = spellEffect.spells) !== null && _b !== void 0 ? _b : {})
            .forEach(function (_a) {
            var _b = __read(_a, 2), spellId = _b[0], spellDelta = _b[1];
            var defineProp = getDefineProp(draft.spells, spellId, spellDelta);
            defineProp('duration', function (prevValue, deltaValue) { return prevValue + deltaValue; });
            defineProp('lineOfSight', function (prevValue, deltaValue) { return deltaValue; });
            defineProp('rangeArea', function (prevValue, deltaValue) { return prevValue + deltaValue; });
            defineProp('actionArea', function (prevValue, deltaValue) { return prevValue + deltaValue; });
            defineProp('attack', function (prevValue, deltaValue) { return (prevValue !== null && prevValue !== void 0 ? prevValue : 0) + deltaValue; });
        });
        draft.time = spellActionLaunchTime;
        draft.checksum = compute_checksum_1.computeChecksum(draft);
    });
};
exports.produceStateFromSpellEffect = produceStateFromSpellEffect;
var getSpellEffectFromSpellRole = function (spellRole, spellEffectParams) { return __awaiter(void 0, void 0, void 0, function () {
    var spellEffectFn, helper, defaultActionArea, defaultDuration, spellEffect;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                spellEffectFn = spell_effects_map_1.getSpellEffectFn(spellRole);
                helper = spell_effects_fn_1.createSpellEffectHelper(spellEffectParams);
                defaultActionArea = helper.getActionArea();
                if (defaultActionArea.length === 0) {
                    return [2 /*return*/, { actionArea: [], duration: -1 }];
                }
                defaultDuration = helper.getDefaultDuration();
                return [4 /*yield*/, spellEffectFn(helper)];
            case 1:
                spellEffect = _a.sent();
                return [2 /*return*/, __assign({ actionArea: defaultActionArea, duration: defaultDuration }, spellEffect)];
        }
    });
}); };
exports.getSpellEffectFromSpellRole = getSpellEffectFromSpellRole;
var produceStateFromSpellRole = function (spellRole, spellEffectParams) { return __awaiter(void 0, void 0, void 0, function () {
    var spellEffect;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.getSpellEffectFromSpellRole(spellRole, spellEffectParams)];
            case 1:
                spellEffect = _a.sent();
                return [2 /*return*/, exports.produceStateFromSpellEffect(spellEffect, spellEffectParams.context.state, spellEffectParams.partialSpellAction.launchTime)];
        }
    });
}); };
exports.produceStateFromSpellRole = produceStateFromSpellRole;
var getSpellRangeArea = function (spellRole, params) {
    var checkTileFn = spell_effects_map_1.getSpellRangeAreaFn(spellRole);
    return compute_range_area_1.computeRangeArea(params, checkTileFn);
};
exports.getSpellRangeArea = getSpellRangeArea;
var produceStateDisconnectedPlayers = function (state, time, removedPlayers, characterPlayerMap) {
    return immer_1.default(state, function (draft) {
        var charactersHealth = common_1.ObjectTyped.entries(draft.characters.health)
            .reduce(function (acc, _a) {
            var _b = __read(_a, 2), characterId = _b[0], health = _b[1];
            var playerId = characterPlayerMap[characterId];
            var isRemovedPlayer = removedPlayers.includes(playerId);
            acc[characterId] = isRemovedPlayer ? 0 : health;
            return acc;
        }, {});
        draft.characters.health = charactersHealth;
        draft.time = time;
        draft.checksum = compute_checksum_1.computeChecksum(draft);
    });
};
exports.produceStateDisconnectedPlayers = produceStateDisconnectedPlayers;
